/**
 * Mã validate
 */
export const VALIDATE_CODE = {
    REQUIRED: 'field.validate.required',
    MAX_LENGTH: 'field.validate.maxLength',
    FORMART_ERROR: 'field.validate.formatError',
    STRONG_FORMAT: 'field.validate.strongFormat',
    DIFFERENT: 'field.validate.different',
    OK: 'field.validate.ok'
};
/**
 * Trường validate
 */
export const FIELD_NAME = {
    SECRET_CODE: 'field.name.secretCode'
};
export const TOOLTIP_FIELD = {
    SHOW: 'field.tooltip.show',
    HIDE: 'field.tooltip.show'
};
